mutation reviewResponse($request_response: String, $review_response: String) {
    reviewResponse(request_response: $request_response, review_response: $review_response)
}
